var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkExpiredArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 610,
    height: 610,
    viewBox: "0 0 610 610",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link_expired_art",
    transform: "translate(-304 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Questions-bro",
    transform: "translate(276.53 263.938)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-25",
    transform: "translate(27.576 49.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M383.366,74.692S471.515,117.4,515.479,183.21s40.485,150.474-12.937,213.319-155.531,54.591-241.027,94.4S81.693,522.541,41.266,438.2s20.533-115.865,31-213.474S175.263-15.814,383.366,74.692Z",
    transform: "translate(18.318 9.757)",
    fill: "#92a1b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M383.366,74.692S471.515,117.4,515.479,183.21s40.485,150.474-12.937,213.319-155.531,54.591-241.027,94.4S81.693,522.541,41.266,438.2s20.533-115.865,31-213.474S175.263-15.814,383.366,74.692Z",
    transform: "translate(18.318 9.757)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks-2--inject-25",
    transform: "translate(74.745 63.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M380.316,360.192V355.6c0-23.623,29.908-24.65,29.908-41.466,0-7.3-5.943-12.065-14.79-12.065-9.682,0-15.8,5.272-15.8,12.749V316.7c0,1.862-1.013,2.739-2.889,2.739l-18.172-.685c-1.7,0-2.889-.849-2.889-2.027V314.85c0-20.541,16.31-34.66,40.275-34.66,23.445,0,38.563,13.256,38.563,33.126,0,28.21-30.415,28.388-30.415,43.822v3.054a2.6,2.6,0,0,1-2.889,2.89H383.205a2.6,2.6,0,0,1-2.889-2.889Zm-1.534,27.389c0-7.477,6.628-13.6,14.612-13.6,7.655,0,14.447,6.121,14.447,13.6s-6.847,13.6-14.612,13.6-14.447-6.149-14.447-13.626Z",
    transform: "translate(46.465 26.671)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M117.218,215.269v-3.985c0-20.541,26.019-21.4,26.019-36.016,0-6.354-5.163-10.476-12.831-10.476-8.422,0-13.694,4.574-13.694,11.065v1.63c0,1.616-.876,2.355-2.506,2.355l-15.789-.589c-1.479,0-2.506-.74-2.506-1.767v-1.63c0-17.8,14.16-30.127,34.975-30.127,20.363,0,33.51,11.517,33.51,28.758,0,24.5-26.43,24.65-26.43,38.084v2.657a2.26,2.26,0,0,1-2.506,2.506H119.724a2.26,2.26,0,0,1-2.506-2.465Zm-1.369,23.76c0-6.491,5.752-11.8,12.681-11.8,6.642,0,12.558,5.313,12.558,11.8s-5.916,11.8-12.695,11.8a12.2,12.2,0,0,1-12.5-11.8Z",
    transform: "translate(-49.5 -23.002)",
    fill: "#92a1b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M355.748,91.236V89.223c0-10.367,13.119-10.818,13.119-18.2,0-3.2-2.616-5.3-6.491-5.3-4.245,0-6.929,2.314-6.929,5.6v.822c0,.822-.452,1.191-1.274,1.191l-7.97-.3c-.753,0-1.274-.37-1.274-.89v-.822c0-9.025,7.162-15.214,17.679-15.214,10.284,0,16.926,5.82,16.926,14.543,0,12.325-13.352,12.448-13.352,19.172v1.369a1.137,1.137,0,0,1-1.274,1.26h-7.9a1.123,1.123,0,0,1-1.26-1.219Zm-.671,12.01a6.4,6.4,0,1,1,6.382,5.957,6.162,6.162,0,0,1-6.382-5.957Z",
    transform: "translate(42.494 -56.11)",
    fill: "#92a1b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M75.687,295.94v-2.533c0-13.064,16.543-13.626,16.543-22.938,0-4.04-3.287-6.669-8.217-6.669-5.354,0-8.737,2.917-8.737,7.053v1.027c0,1.041-.561,1.506-1.6,1.506l-10.052-.37c-.945,0-1.6-.479-1.6-1.137v-1.027c0-11.366,9.024-19.172,22.281-19.172,12.968,0,21.322,7.326,21.322,18.323,0,15.6-16.817,15.694-16.817,24.253v1.684a1.438,1.438,0,0,1-1.6,1.6H77.262a1.438,1.438,0,0,1-1.575-1.6Zm-.849,15.132a8.052,8.052,0,1,1,8,7.518,7.778,7.778,0,0,1-8.025-7.518Z",
    transform: "translate(-62.02 16.138)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M166.508,119.592v-1.739c0-8.983,11.38-9.381,11.38-15.776,0-2.739-2.26-4.588-5.628-4.588-3.684,0-6.012,2-6.012,4.848v.712c0,.712-.383,1.027-1.1,1.027l-6.847-.26c-.644,0-1.1-.315-1.1-.767v-.712c0-7.819,6.2-13.188,15.31-13.188s14.53,5.039,14.53,12.6c0,10.736-11.572,10.8-11.572,16.68v1.164a.986.986,0,0,1-1.1,1.1h-6.847a.986.986,0,0,1-1.027-1.1ZM165.933,130a5.478,5.478,0,1,1,5.478,5.176,5.341,5.341,0,0,1-5.519-5.149Z",
    transform: "translate(-26.854 -43.904)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M314.508,393.742V392c0-8.983,11.38-9.367,11.38-15.776,0-2.739-2.26-4.588-5.628-4.588-3.684,0-6.012,2-6.012,4.848v.712c0,.712-.383,1.041-1.1,1.041l-6.847-.26c-.644,0-1.1-.329-1.1-.781v-.712c0-7.819,6.2-13.188,15.31-13.188s14.68,5.039,14.68,12.612c0,10.723-11.572,10.791-11.572,16.666v1.164a1,1,0,0,1-1.1,1.109h-6.847a1,1,0,0,1-1.178-1.109Zm-.575,10.408a5.478,5.478,0,1,1,5.478,5.177,5.341,5.341,0,0,1-5.464-5.177Z",
    transform: "translate(27.82 57.374)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-mark-1--inject-25",
    transform: "translate(212.18 242.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M295.285,419.114c-.1-.288-.192-.575-.3-.863s-.192-.589-.3-.876-.192-.575-.3-.863-.192-.589-.3-.876-.192-.575-.3-.863-.192-.589-.3-.876l-.3-.863c-.1-.3-.205-.589-.3-.876l-.3-.863c-.1-.3-.205-.589-.3-.877l-.3-.863c-.1-.3-.205-.589-.3-.876l-.288-.917c-.1-.3-.205-.589-.3-.876l-.315-.863c-.1-.3-.192-.589-.3-.876s-.192-.575-.3-.863-.192-.589-.3-.876-.192-.575-.3-.863c-4.464-13.585-18.268-23.554-33.455-23.554-14.721,0-27.525,8.573-32.866,20.651-.137.274-.26.562-.383.835l-.37.849c-.137.274-.26.548-.383.835s-.26.561-.383.835l-.37.835c-.137.288-.26.561-.383.849s-.26.548-.383.835-.26.548-.383.835l-.37.835c-.137.274-.26.561-.383.835s-.26.561-.383.835l-.37.849c-.137.274-.26.548-.383.835s-.26.561-.383.835l-.37.835c-.137.288-.26.561-.383.849s-.26.548-.383.835l-.37.835c-.137.274-.26.562-.383.835s-.26.561-.383.849a37.261,37.261,0,0,0-3.533,16c0,22.048,19.035,40.069,42.575,40.069,23.034,0,43.068-18.022,43.068-40.069a36.18,36.18,0,0,0-2.177-12.325A7.57,7.57,0,0,0,295.285,419.114Z",
    transform: "translate(-144.005 -115.759)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M281.082,186.8c-70.621,0-118.7,41.562-118.7,102.173v5.478a5.259,5.259,0,0,0,2.6,4.464,6.722,6.722,0,0,0,.959.767,105672.809,105672.809,0,0,1,1.945,1.534,5.477,5.477,0,0,0,.972.767,5.886,5.886,0,0,0,.959.767,6.062,6.062,0,0,0,.972.781,6.845,6.845,0,0,0,.972.767,6.161,6.161,0,0,0,.972.767,6.042,6.042,0,0,0,.959.767,6.371,6.371,0,0,0,1.054.822,7.7,7.7,0,0,0,.89.7,6.846,6.846,0,0,0,.972.767,6.724,6.724,0,0,0,.959.767,6.845,6.845,0,0,0,.972.767,6.162,6.162,0,0,0,.972.767,6.042,6.042,0,0,0,.959.767,6.158,6.158,0,0,0,.972.767,6.038,6.038,0,0,0,.959.767,6.846,6.846,0,0,0,.972.767,6.04,6.04,0,0,0,.959.767,8.066,8.066,0,0,0,5.752,2l44.041,1.643c4.533,0,7-2.054,7-6.587v-4.519c0-18.117,14.817-30.867,38.344-30.867,21.4,0,35.81,11.517,35.81,29.224a31.653,31.653,0,0,1-.576,6.018c-22.1,28.97-79.631,41.747-79.631,97.989v13.53c0,5.478,3,8.5,8.518,8.5h53.024c5.478,0,8.518-3,8.518-8.5v-9.025c0-45.574,89.656-46.081,89.656-129.219C394.785,225.856,350.2,186.8,281.082,186.8Z",
    transform: "translate(-162.38 -186.759)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M235,422.722v-13.53c0-69.622,88.15-72.579,88.15-122.207,0-21.541-17.529-35.605-43.575-35.605-28.553,0-46.561,15.529-46.561,37.563v5.478c0,5.478-3.013,8.025-8.518,8.025l-53.6-2.013c-5,0-8.5-2.506-8.5-6.012v-5.478c0-60.611,48.08-102.173,118.7-102.173,69.115,0,113.662,39.056,113.662,97.667,0,83.138-89.656,83.645-89.656,129.219v9.025c0,5.478-3.013,8.5-8.518,8.5H243.515C238,431.226,235,428.227,235,422.722Zm-4.505,80.7c0-22.034,19.528-40.069,43.068-40.069,22.541,0,42.575,18.035,42.575,40.069s-20.076,40-43.068,40C249.5,543.423,230.492,525.4,230.492,503.422Z",
    transform: "translate(-162.376 -186.77)",
    fill: "#92a1b6",
    stroke: "#92a1b6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 74.784,
    cy: 16.721,
    rx: 74.784,
    ry: 16.721,
    transform: "translate(33.715 368.115)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-25",
    transform: "translate(244.033 37.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M205.127,190.85l-2.862,6.245s-16.625,1.794-16.625,3.04.178,9.832,1.082,10.189a2.944,2.944,0,0,0,2.136,0l24.485-6.258,2.328-11.079Z",
    transform: "translate(-185.64 19.75)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M200.069,199.661a59.505,59.505,0,0,1-9.791,6.518c-3.958,1.78-4.108,4.478-2.848,4.478s12.434-4.683,12.434-4.683,10.147-2.657,11.613-3.465,1.63-5.3,1.63-5.3",
    transform: "translate(-185.238 22.1)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M215.223,103.23l-10.216,78.3-7.107,42.4,15.776,3.725,11.763-50.148,5.574-31.565Z",
    transform: "translate(-181.111 -12.619)",
    fill: "#7d7d7d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M276,63.4l-6.231-.986L257.006,57.58l-.466,15.16,19.788,1.821Z",
    transform: "translate(-159.448 -29.483)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M221.892,265.631a192.1,192.1,0,0,0-13,16.981c-5.272,8.052-3.41,16.707,3.095,18.884s14.845-3.725,17.022-8.367,1.547-7.107,4.944-11.75,6.19-9.285,4.957-15.474S225.233,261.3,221.892,265.631Z",
    transform: "translate(-178.18 45.964)",
    fill: "#7d7d7d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M228.371,288.335c-.438-.931-.945-1.917-1.547-2.972-4.971-8.751-13.694-8.052-19.172-6.423-3.6,7.354-1.547,14.667,4.355,16.638S225.522,292.731,228.371,288.335Z",
    transform: "translate(-178.167 51.922)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M226.774,290.205c-1.849,2.739-4.327,10.216-13.927,7.121A13.229,13.229,0,0,1,206,293.013a9.025,9.025,0,0,0,5.984,7.409c6.491,2.164,14.845-3.725,17.022-8.367s1.547-7.107,4.944-11.75,6.19-9.285,4.957-15.474c0,7.422-2.739,8.655-6.19,12.681S228.637,287.412,226.774,290.205Z",
    transform: "translate(-178.118 47.081)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M288.922,265.631a192.112,192.112,0,0,1,13,16.981c5.272,8.052,3.41,16.707-3.095,18.884s-14.845-3.725-17.022-8.367-1.547-7.107-4.944-11.75-6.19-9.285-4.957-15.474S285.526,261.3,288.922,265.631Z",
    transform: "translate(-153.883 45.964)",
    fill: "#7d7d7d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M279.52,288.335c.425-.931.931-1.917,1.534-2.972,4.971-8.751,13.694-8.052,19.172-6.423,3.6,7.354,1.547,14.667-4.355,16.638S282.355,292.731,279.52,288.335Z",
    transform: "translate(-150.958 51.922)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M283.993,290.205c1.849,2.739,4.327,10.216,13.927,7.121a13.229,13.229,0,0,0,6.847-4.314,9.025,9.025,0,0,1-5.984,7.409c-6.491,2.164-14.845-3.725-17.022-8.367s-1.547-7.107-4.944-11.75-6.19-9.285-4.957-15.474c0,7.422,2.739,8.655,6.19,12.681S282.131,287.412,283.993,290.205Z",
    transform: "translate(-153.898 47.081)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M327.075,193.135c0-5.574-9.586-11.763-9.586-11.763-14.447-14.694-40.521-12.749-50.148-11.435-9.586-1.369-35.687-3.259-50.135,11.435,0,0-9.586,6.19-9.586,11.763S219.7,299.293,219.7,299.293s-.315,5.259,8.353,5.875,12.325-4.327,12.325-4.327l3.41-85.11s13.927-9.915,16.433-10.216c.9-.123,2.082-.315,3.4-.479v.164a18.213,18.213,0,0,1,7.436,0v-.164c1.369.164,2.479.356,3.4.479,2.479.3,16.433,10.216,16.433,10.216l3.41,85.11s3.711,4.944,12.325,4.327,8.353-5.875,8.353-5.875S327.075,198.708,327.075,193.135Z",
    transform: "translate(-177.52 11.687)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M268.453,210.729s-1.862-20.432,7.121-28.169",
    transform: "translate(-155.106 16.688)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M235.649,211.73s.931-17.022-.931-23.212-4.957-8.668-4.957-8.668",
    transform: "translate(-169.341 15.687)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M242.42,173.52s9.9,11.448,11.763,21.048",
    transform: "translate(-164.664 13.348)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M259.91,174s-5.574,6.19-6.19,10.832",
    transform: "translate(-160.49 13.526)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M255,86.127s-8.97-1.246-12.065,1.849-13.626,14.5-13.626,14.5l5.574,98.421s12.695,4.957,23.527,4.957,23.212-4.026,26.019-6.19.315-107.705.315-107.705S261.752,85.2,255,86.127Z",
    transform: "translate(-169.507 -19.029)",
    fill: "#92a1b6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M261.373,97.8A112.844,112.844,0,0,1,275.6,96.557c6.19,0,12.325.315,12.325.315L303.4,82.014l-31.141-7.121,2.479-14.228s22.9-1.547,34.345.616,29.4,7.737,30.333,7.737,2.164,3.41,1.232,5.875S310.6,109.567,301.907,117.92a213.534,213.534,0,0,0-16.091,17.638l-3.971,69.019s10.216,5.574,12.078,7.422,4.026,9.285,4.026,9.285-18.884-7.737-23.842-8.353-8.038-.931-8.97-2.739S256.47,125.7,256.47,125.7l.315-26.307S256.73,97.8,261.373,97.8Z",
    transform: "translate(-159.474 -28.541)",
    fill: "#7d7d7d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M278.121,118.6,261.4,120.764l1.547,6.19,8.367,2.164,8.038-3.711Z",
    transform: "translate(-157.652 -6.941)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M281.611,91.48l-3.711,32.5,9.6-27.539",
    transform: "translate(-151.557 -16.959)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M290.78,76.945s7.737,1.547,19.5-3.095",
    transform: "translate(-146.799 -23.472)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M296.66,78.022a69.937,69.937,0,0,0,15.16-1.232",
    transform: "translate(-144.626 -22.386)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M240.39,85.83l1.547,22.6A14.886,14.886,0,0,0,254,114.3c7.737-.3,8.669-5.875,8.669-5.875V89.856Z",
    transform: "translate(-165.414 -19.047)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M257.046,97.8l-.616,18.6,6.5-10.216s7.121,8.97,8.97,8.668-1.232-4.026-1.849-7.422-5.889-15.488-6.5-18.884-6.5-4.026-6.847-2.479a15.8,15.8,0,0,0,0,4.026Z",
    transform: "translate(-159.488 -19.255)",
    fill: "#7d7d7d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M252.665,113.893s1.232,86.657-1.862,87.643-15.475,1.246-23.28,4.957-11.448,5.259-11.448,5.259,3.711-8.97,8.052-13a42.741,42.741,0,0,1,9.586-6.5l-8.038-41.466s-14.858-39.316-15.173-41.48,28.169-18.254,34.044-21.048,7.436-.3,7.436-.3Z",
    transform: "translate(-176.457 -18.639)",
    fill: "#7d7d7d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M237.875,85s-7.422,23.527-8.052,26.622,0,3.095,2.177.918,7.737-7.422,7.737-7.422l5.875,9.9L245.3,96.764V86.233S245,81.906,237.875,85Z",
    transform: "translate(-169.404 -19.765)",
    fill: "#7d7d7d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M225.1,121.77h18.254l-.3,7.422-8.052,2.78-10.216-2.78Z",
    transform: "translate(-171.177 -5.769)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M274.146,65.086S278.474,83.957,279.4,87s-4.944,15.173-6.847,17.953a9.011,9.011,0,0,1-6.847,4.327c-2.164,0-13.927-4.012-16.721-5.875s-5.56-4.026-5.56-4.026a7.436,7.436,0,0,1-8.052-1.233c-3.711-3.41-8.668-7.436-7.436-10.216a7.272,7.272,0,0,1,7.121-4.327c3.41,0,2.177-.315,2.177-.315s-6.19-8.97-6.19-16.091,13.3-12.325,21.034-12.325a41.329,41.329,0,0,1,15.474,3.711Z",
    transform: "translate(-170.084 -30.484)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M254.389,67.52l5.574,10.531-5.574,3.711-2.479-3.095",
    transform: "translate(-161.158 -25.811)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M262.1,74.53s.3,2.479-3.41,6.5",
    transform: "translate(-158.654 -23.221)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M250.169,71.059c0,1.452-.63,2.629-1.369,2.629s-1.369-1.178-1.369-2.629.63-2.629,1.369-2.629S250.169,69.608,250.169,71.059Z",
    transform: "translate(-162.813 -25.475)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 1.397,
    cy: 2.629,
    rx: 1.397,
    ry: 2.629,
    transform: "translate(95.695 37.998)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M242.651,55.56s-19.473,7.121-20.117,16.1,17.337,21.349,18.268,22.9,3.711-1.862,3.711-1.862a7.189,7.189,0,0,1-1.246-5.875c.931-3.095,4.957-6.847,4.957-8.354s-4.642,1.232-4.642-3.41,11.448-7.422,18.254-7.121,12.695,11.763,17.652,6.19-2.177-7.107-2.177-7.107,9.586-1.246,9.586-6.19-4.957-8.367-7.121-8.367-8.039,3.725-8.039-.3,5.875-5.889.3-12.325-12.681,0-12.681,2.479-1.862,7.107-3.095,7.107-4.957-5.56-9.285-2.465a11.476,11.476,0,0,0-4.327,8.6Z",
    transform: "translate(-172.016 -37.063)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    y1: 3.725,
    x2: 9.901,
    transform: "translate(78.687 38.614)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M251.481,62.868a4.258,4.258,0,0,1,.438-2.848",
    transform: "translate(-161.346 -28.581)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M251.78,61.234c.7-1.369,2.273-3.136,5.752-4.574",
    transform: "translate(-161.206 -29.823)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 610,
    height: 610,
    transform: "translate(304 299)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExpiredArt);
export default __webpack_public_path__ + "static/media/link_expired_art.1a60f57dd177dd83e8aa48823696b662.svg";
export { ForwardRef as ReactComponent };